import { getRequest } from "../config/axiosConfig";

class TransactionService {
    baseUrl: string;

    constructor() {
        this.baseUrl = "transaction/" + process.env.REACT_APP_WEBSITE_BRAND;
    }

    async getTransaction(transactionId: string) {
        return await getRequest(`${this.baseUrl}?transactionId=${transactionId}`);
    }
}

export default TransactionService;
